import Layout from './src/index';

export * from './src/index';
export default Layout;
